import { render } from "./rectorStudioManager.vue?vue&type=template&id=8eec9296&scoped=true"
import script from "./rectorStudioManager.vue?vue&type=script&lang=js"
export * from "./rectorStudioManager.vue?vue&type=script&lang=js"

import "./rectorStudioManager.vue?vue&type=style&index=0&id=8eec9296&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eec9296"]])

export default __exports__